import { Controller } from '@hotwired/stimulus';
import { get } from '@rails/request.js';
import * as bootstrap from 'bootstrap';
import { initServerSideDataTable, escapeHtml } from '../src/server_side_datatable';

export default class extends Controller {
  static targets = [
    'polsItemDetailContainer',
    'polsItemDetailAttributes',
    'confirmDeleteModal',
    'modalEditPolsItemDetail',
    'itemDetailsTable',
  ];

  connect() {
    this.checkPolStatus();
    this.disableCheckboxCompleted();
  }

  disableCheckboxCompleted() {
    const $polsItemDetailAttributes = $(this.polsItemDetailAttributesTarget);
    const itemDetailCount = $polsItemDetailAttributes.find('div').length;
    if (itemDetailCount == 0) {
      const polStatus = document.getElementById('pol_status');
      polStatus?.setAttribute('disabled', 'true');
    }
  }

  initialize() {
    this.initialDataTables();
  }

  checkPolStatus() {
    const polStatus = document.getElementById('pol_status');
    if (polStatus) {
      if (polStatus.value == 'complete') {
        document
          .getElementById('checkboxConfirmCompletedPol')
          ?.setAttribute('disabled', 'true');
      }
    }
  }

  confirmCompletedPol(e) {
    this.myModal($('#confirmCompletedPol')).show();
  }

  cancelCompletedPol(e) {
    document.getElementById('checkboxConfirmCompletedPol').checked = false;
  }

  confirmCompleted() {
    document.getElementById('pol_status').value = 'complete';
    document.forms['formEditPol'].submit();
  }

  confirmDelete() {
    const modal = $(this.confirmDeleteModalTarget);
    modal.find('#sku').text($('#editPolsItemDetailSku').val());
    this.myModal(this.confirmDeleteModalTarget).show();
  }

  cancelDelete() {
    this.modalEditPolsItemDetailTarget.querySelector('turbo-frame').reload();
    this.myModal(this.modalEditPolsItemDetailTarget).show();
  }

  submitPolsItemDetail(e) {
    $('#form-pols-item-detail').submit();
  }

  submitAddMorePolsItemDetail(e) {
    const addMore = parseInt($('#editPolsItemDetailAddMoreQTY').val());
    let itemCount = parseInt($('#editPolsItemDetailNeedQty').val());
    const control = async () => {
      const itemDetailId = $('#pols_item_detail_item_detail_id').val();
      const polId = $('#pol_id').val();
      for (let i = 0; i < addMore; i += 1) {
        $('#ItemsAttributes').append(`
          <div id="polsItemDetail-${polId}-Item-new">
            <input type="hidden" value="${itemDetailId}" name="pols_item_detail[items_attributes][${itemCount}][item_detail_id]" id="pols_item_detail_items_attributes_${itemCount}_item_detail_id">
            <input type="hidden" value="false" name="pols_item_detail[items_attributes][${itemCount}][_destroy]">
          </div>`);
        itemCount += 1;
      }
    };
    if (addMore > 0) {
      control();
    }
    $("input[type=checkbox][name='item']").each((index, item) => {
      $(`#item-${item.value}`).val('false');
    });
    $('#form-pols-item-detail').submit();
  }

  hidePolsItemDetailContainer() {
    const $polsItemDetailAttributes = $(this.polsItemDetailAttributesTarget);
    const itemDetailCount = $polsItemDetailAttributes.find('div').length;

    if (itemDetailCount === 0) {
      this.polsItemDetailContainerTarget.classList.add('d-none');
    }
  }

  openEditPolsItemDetailModal(e) {
    e.preventDefault();
    const frame = this.modalEditPolsItemDetailTarget.querySelector('turbo-frame');
    frame.src = e.params.url;
    this.myModal(this.modalEditPolsItemDetailTarget).show();
  }

  myModal(element) {
    return (
      bootstrap.Modal.getInstance(element) || new bootstrap.Modal(element, { keyboard: false })
    );
  }

  // SKU list on the POL edit page, rows come from PolsItemDetailsController#index (JSON).
  initialDataTables() {
    if (!this.hasItemDetailsTableTarget) {
      return;
    }

    initServerSideDataTable(this.itemDetailsTableTarget, {
      renderers: {
        edit: (row) => `
          <i class="fal fa-edit color-blue pointer"
             data-action="click->pol#openEditPolsItemDetailModal"
             data-pol-url-param="${escapeHtml(row.edit_url)}"></i>`,
      },
    });
  }

  seeMoreLogs() {
    const polId = $('#pol_id').val();
    const url = `/pols/${polId}/logs`;

    this.myModal($('#logsModal')).show();
    get(url, {
      responseKind: 'turbo-steam',
    });
  }

  openSendMailModal() {
    this.myModal($('#sendMailModal')).show();
  }

  sendingMail(e) {
    const form = document.getElementById('send-mail-form');
    form.submit();
  }
}
